import React, { useEffect } from "react";
import { Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import IntlMessages from "@util/IntlMessages";
import { getListStructure } from "services/api/Api";
import { useIntl } from "react-intl";
import PopoverTip from "../../../TipPopover/PopoverTip";
import { showName, validateTranslations } from "@util/Scripts";
import { useWidgetSettings } from "@util/customHooks";
import { Message, Button, Input } from "../../../BP2Components";
const { Option } = Select;

const BlogCarouselSettings = (props) => {
   const dispatch = useDispatch();
   const intl = useIntl();
   const { allLanguages } = useSelector(({ settings }) => settings);
   const { value, columns, data } = props;
   const { settings, setSettings, handleChange, syncTranslations } = useWidgetSettings(
      { ...value, columns },
      {
         sync: [
            { keyField: "titleTranslationKey", category: "blogCarousel.name", valuePrefix: "name" },
         ],
         translations: [{ translationKey: value.titleTranslationKey }],
      },
   );

   const handleSubmit = (e) => {
      e.preventDefault();

      const validTranslations = validateTranslations(settings);

      if (!validTranslations) {
         Message.error(intl.formatMessage({ id: "widget.invalidTranslations" }));
         return;
      }

      dispatch(setWidgetInSheetParams(settings));
      syncTranslations(settings);
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };

   const handleChangeList = (e) => {
      getListStructure(settings.listId).then((res) => {
         const responseData = res.data.getStructure;
         if (responseData.columns !== undefined && responseData.columns !== null) {
            setSettings({
               ...settings,
               columns: responseData.columns,
            });
         }
      });
   };
   useEffect(() => {
      const updates = {};
      allLanguages.forEach((item) => {
         const key = `name${item.language}`;
         const val = settings[key];
         if (typeof val === "object") {
            updates[key] = "";
         } else if (typeof val !== "string") {
            updates[key] = showName(item.language, value.titleTranslationKey, data);
         }
      });
      if (Object.keys(updates).length > 0) {
         setSettings((prev) => ({ ...prev, ...updates }));
      }
   }, [settings.namesp, settings.nameen, settings.namepl, settings.namede]);
   const options =
      settings &&
      settings.columns !== undefined &&
      settings.columns.map((col) => (
         <Option
            key={col.label}
            value={col?.options?.techName ? col?.options?.techName : col.label}
         >
            {col.label}
         </Option>
      ));

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div className="widget-settings__inner">
                  <label className="widget-settings__inner__label" key="title">
                     <IntlMessages id="settings.listId" />:
                     <div style={{ display: "flex", alignItems: "center", width: "180px" }}>
                        <Input
                           type="text"
                           name="listId"
                           defaultValue={value.listId}
                           onChange={(e) => handleChange(e.target.value, e.target.name)}
                           style={{ width: "100px" }}
                        />
                        <Button
                           className="gx-ml-1"
                           buttonType="primary"
                           onClick={handleChangeList}
                           style={{ marginRight: "50%" }}
                        >
                           <IntlMessages id="settings.changeId" />
                        </Button>
                     </div>
                  </label>
                  <label className="widget-settings__inner__label" key="widgetTitle">
                     <IntlMessages id="settings.widgetTitle" />:
                     <Input
                        type="widgetTitle"
                        name="widgetTitle"
                        onChange={handleChange}
                        style={{ width: "300px" }}
                        defaultValue={value.widgetTitle}
                     />
                  </label>
                  <label className="widget-settings__inner__label" key="titleTranslationKey">
                     <IntlMessages id="settings.widgetTitleTranslationKey" />:
                     <Input
                        type="titleTranslationKey"
                        name="titleTranslationKey"
                        defaultValue={value.titleTranslationKey}
                        onChange={handleChange}
                        style={{ width: "300px" }}
                     />
                  </label>
                  {allLanguages.map((item) => (
                     <label className="widget-settings__inner__label" key={item.language}>
                        <IntlMessages id={`widgetTitle${item.language}`} />:
                        <Input
                           type="translation"
                           className="translationName"
                           name={`name${item.language}`}
                           defaultValue={
                              settings[`name${item.language}`]
                                 ? settings[`name${item.language}`]
                                 : showName(`${item.language}`, value.titleTranslationKey, data)
                           }
                           onChange={(e) => handleChange(e.target.value, e.target.name)}
                           style={{ width: "300px" }}
                        />
                     </label>
                  ))}
                  <label className="widget-settings__inner__label" key="singleItemTitleColumn">
                     <IntlMessages id="settings.singleItemTitleColumn" />:
                     <Select
                        key="singleItemTitleColumn"
                        name="singleItemTitleColumn"
                        style={{ width: 220 }}
                        onChange={(v) => handleChange(v, "singleItemTitleColumn")}
                        defaultValue={
                           settings.singleItemTitleColumn !== null
                              ? settings.singleItemTitleColumn
                              : "----Select----"
                        }
                     >
                        {options}
                     </Select>
                     <PopoverTip
                        title={intl.formatMessage({ id: "settings.singleItemTitleColumn" })}
                        content={intl.formatMessage({ id: "settings.singleItemTitleColumnTip" })}
                     />
                  </label>
                  <label className="widget-settings__inner__label" key="subtitleColumn">
                     <IntlMessages id="settings.subtitleColumn" />:
                     <Select
                        key="subtitleColumn"
                        name="subtitleColumn"
                        style={{ width: 220 }}
                        onChange={(v) => handleChange(v, "subtitleColumn")}
                        defaultValue={
                           settings.subtitleColumn !== null
                              ? settings.subtitleColumn
                              : "----Select----"
                        }
                     >
                        {options}
                     </Select>
                     <PopoverTip
                        title={intl.formatMessage({ id: "settings.subtitleColumn" })}
                        content={intl.formatMessage({ id: "settings.subtitleColumnTip" })}
                     />
                  </label>
                  {value?.widgetType === "multipleDataType" ? (
                     <label className="widget-settings__inner__label" key="columnDataType">
                        <IntlMessages id="settings.dataSourceColName" />:
                        <Select
                           key="columnDataType"
                           name="columnDataType"
                           style={{ width: 220 }}
                           onChange={(v) => handleChange(v, "columnDataType")}
                           defaultValue={
                              settings.columnDataType !== null
                                 ? settings.columnDataType
                                 : "----Select----"
                           }
                        >
                           {options}
                        </Select>
                        <PopoverTip
                           title={intl.formatMessage({ id: "settings.dataSourceColName" })}
                           content={intl.formatMessage({ id: "settings.dataSourceColNameTip" })}
                        />
                     </label>
                  ) : (
                     <label className="widget-settings__inner__label" key="bannerTitle">
                        <IntlMessages id="settings.miniatureImageColName" />:
                        <Select
                           key="bannerTitle"
                           name="bannerTitle"
                           style={{ width: 220 }}
                           onChange={(v) => handleChange(v, "bannerTitle")}
                           defaultValue={
                              settings.bannerTitle !== null
                                 ? settings.bannerTitle
                                 : "----Select----"
                           }
                        >
                           {options}
                        </Select>
                        <PopoverTip
                           title={intl.formatMessage({ id: "settings.miniatureImageColName" })}
                           content={intl.formatMessage({ id: "settings.miniatureImageColNameTip" })}
                        />
                     </label>
                  )}
                  <label
                     className="widget-settings__inner__label"
                     key="singleItemDescriptionColumn"
                  >
                     <IntlMessages id="settings.ItemHTMLContentColName" />:
                     <Select
                        key="singleItemDescriptionColumn"
                        name="singleItemDescriptionColumn"
                        style={{ width: 220 }}
                        onChange={(v) => handleChange(v, "singleItemDescriptionColumn")}
                        defaultValue={
                           settings.singleItemDescriptionColumn !== null
                              ? settings.singleItemDescriptionColumn
                              : "----Select----"
                        }
                     >
                        {options}
                     </Select>
                     <PopoverTip
                        title={intl.formatMessage({ id: "settings.ItemHTMLContentColName" })}
                        content={intl.formatMessage({ id: "settings.ItemHTMLContentColNameTip" })}
                     />
                  </label>
                  <label className="widget-settings__inner__label" key="widgetType">
                     <IntlMessages id="settings.widgetType" />:
                     <Select
                        key="widgetType"
                        name="widgetType"
                        style={{ width: 220 }}
                        onChange={(v) => handleChange(v, "widgetType")}
                        defaultValue={
                           settings?.widgetType !== "" ? settings?.widgetType : "threeItems"
                        }
                     >
                        <Option value="threeItems">Three Items</Option>
                        <Option value="oneBigItem">One Big Item</Option>
                        <Option value="multipleDataType">3 items multiple data type</Option>
                     </Select>
                  </label>
               </div>
               <Button key="btn" buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default BlogCarouselSettings;
